import React, { useEffect, useState } from 'react';
import Image from 'next/image';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import { Form } from 'components/FormikForm';
import Link from 'components/Link';
import { LoginForm } from 'components/Login/_components/LoginForm';
import { MFAVerification } from 'components/Login/_components/MFAVerification';
import { TermsConsent } from 'components/Login/_components/TermsConsent';
import { PrivacyPolicy } from 'components/Login/_components/PrivacyPolicy';
import { Afp } from 'components/Login/_components/Afp';
import LoginService from 'services/LoginService';
import { getQueryParam } from 'helpers/queryParams';
import { LoginProvider, useLoginContext } from 'components/Login/_context/useLoginContext';
import './styles.css';

const LOGIN_LOGO = '/static/images/STLogoSmall.svg';

const Login: React.FC = () => {
    const {
        runChecksAndLogin,
        requirePrivacy,
        requireTerms,
        requirePhone,
        requireMfa,
        requireAfp,
        isEmailVerified,
        handleLoginError,
        setIsValidCredentials,
        isValidCredentials,
    } = useLoginContext();
    const [loading, setLoading] = useState(false);

    const handleLogin = async ({ email, password }) => {
        setIsValidCredentials(true);

        if (!isEmailVerified) return;
        setLoading(true);

        try {
            await LoginService.login({ email, password });
            await runChecksAndLogin({ otp_expires: null });
        } catch (err) {
            setLoading(false);
            handleLoginError(err);
        }
    };

    const renderAuthStep = () => {
        if (requirePrivacy)
            return <PrivacyPolicy/>;

        if (requireTerms)
            return <TermsConsent/>;

        if (requireMfa || requirePhone)
            return <MFAVerification/>;

        if (requireAfp)
            return <Afp/>;

        return (
            <Form
                initialValues={{
                    email: getQueryParam('email') || '',
                    password: '',
                }}
                onSubmit={handleLogin}
                className="w-100"
            >
                <LoginForm loading={loading} isValidCredentials={isValidCredentials}/>
            </Form>
        );
    };

    useEffect(() => {
        LoginService.logout();
    }, []);

    return (
        <Container>
            <Row>
                <Col
                    md={{ span: 10, offset: 1 }}
                    lg={{ span: 8, offset: 2 }}
                    className="d-flex flex-column align-items-center justify-content-center"
                >
                    <Link to="/" className="login__st-logo">
                        <Image width={200} height={50} src={LOGIN_LOGO} alt="Login logo"/>
                    </Link>
                    {renderAuthStep()}
                </Col>
            </Row>
        </Container>
    );
};

const LoginContainer = props => <LoginProvider><Login {...props}/></LoginProvider>;

export default LoginContainer;
